'use strict';
const mmWidgets = require('./mm-widgets');

require('./section-handler-widget');
require('./show-progress-message');
require('./show-error');

mmWidgets.fn.receiptsWidget = function (receiptsModel) {
	return mmWidgets.each(this, function () {
		const element = this.sectionHandlerWidget(),
			receiptTemplate = element.find('[data-mm-role~="receipt-template"]').detach().removeAttr('data-mm-role'),
			receiptContainer = element.find('[data-mm-role~="receipt-container"]'),
			showReceipt = (receipt, isInvoice) => {
				const receiptItem = receiptTemplate.clone(),
					receiptDate = new Date(receipt.timestamp * 1000),
					amount = receipt.amount / 100;

				receiptItem.find('[data-mm-role~="receipt-date"]').text(receiptDate.toLocaleDateString());
				receiptItem.find('[data-mm-role~="receipt-amount"]').text(`${amount} ${receipt.currency}`);
				if (isInvoice) {
					receiptItem.find('[data-mm-role~="unpaid-invoice-link"]').attr('href', receipt.hostedInvoiceUrl);
					receiptItem.find('[data-mm-role~="receipt-link"]').remove();
				} else {
					receiptItem.find('[data-mm-role~="unpaid-invoice-link"]').remove();
					receiptItem.find('[data-mm-role~="receipt-link"]').attr('href', receipt.hostedInvoiceUrl);
				}
				receiptContainer.append(receiptItem);

			},
			timestampDescending = (r1, r2) => {
				return r2.timestamp - r1.timestamp;
			},
			showReceipts = (receipts) => {
				if (receipts && receipts.length) {
					receiptContainer.empty();
					receipts.sort(timestampDescending).forEach(receipt => showReceipt(receipt));
					element.showSection('receipt-list');
				} else {
					element.showSection('empty-receipt-list');
				}
			},
			showUnpaidInvoices = (invoices) => {
				if (invoices && invoices.length === 1) {
					receiptContainer.empty();
					invoices.sort(timestampDescending).forEach(invoice => showReceipt(invoice, true));
					element.showSection('unpaid-invoice-list');
				} else {
					element.showSection('unexpected-unpaid-invoice-count');
				}
			};

		receiptsModel.addEventListener('loadingUnpaidInvoices', () => {
			element.showProgressMessage('Loading unpaid invoice, please wait...');
		});

		receiptsModel.addEventListener('loadingReceipts', () => {
			element.showProgressMessage('Loading receipts, please wait...');
		});
		receiptsModel.addEventListener('loadedReceipts', showReceipts);
		receiptsModel.addEventListener('loadedUnpaidInvoices', showUnpaidInvoices);
		receiptsModel.addEventListener('error', reason => element.showError(reason));
	});

};
